import { Component, Input } from '@angular/core';

@Component({
    selector: 'ngx-button',
    styleUrls: ['./button.component.scss'],
    templateUrl: './button.component.html',
    standalone: false
})
export class ButtonComponent {
  @Input() icon: string;
  @Input() disabled: boolean;
  @Input() status: string;
  @Input() type = 'button';
  @Input() size: string = 'medium';
  @Input() shape: string = 'rectangle';
  @Input() isLoading = false;
  @Input() fullWidth = false;
  buttons = [
    {
      status: 'primary',
      container: 'primary-container',
      containerTitle: 'Primary Button',
      title: 'Primary',
      default: '#0054A6',
    },
    {
      status: 'warning',
      container: 'warning-container',
      containerTitle: 'Warning Button',
      title: 'Warning',
      default: '#ffcb17',
    },
    {
      status: 'success',
      container: 'success-container',
      containerTitle: 'Success Button',
      title: 'Success',
      default: '#00d977',
    },
    {
      status: 'info',
      container: 'info-container',
      containerTitle: 'Info Button',
      title: 'Info',
      default: '#0088ff',
    },
    {
      status: 'danger',
      container: 'danger-container',
      containerTitle: 'Danger Button',
      title: 'Danger',
      default: '#ff0000',
    },
  ];
}
